/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { themeSetThemeKeys } from '../fn/theme/theme-set-theme-keys';
import { ThemeSetThemeKeys$Params } from '../fn/theme/theme-set-theme-keys';

@Injectable({ providedIn: 'root' })
export class ThemeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `themeSetThemeKeys()` */
  static readonly ThemeSetThemeKeysPath = '/api/Theme/{productId}/theme/setThemeKeys';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `themeSetThemeKeys()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  themeSetThemeKeys$Response(params: ThemeSetThemeKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return themeSetThemeKeys(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `themeSetThemeKeys$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  themeSetThemeKeys(params: ThemeSetThemeKeys$Params, context?: HttpContext): Observable<void> {
    return this.themeSetThemeKeys$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
